export default __webpack_public_path__ + "static/media/data_setting_4.6ef79b02.png";